var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "editarVehiculoConecta",
      attrs: { fluid: "", "grid-list-md": "" }
    },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [
          _vm.rolUser.length > 0
            ? _c(
                "v-tab",
                {
                  on: {
                    click: function($event) {
                      return _vm.selectTab("general")
                    }
                  }
                },
                [_vm._v("Huella de Carbono General")]
              )
            : _vm._e(),
          _c(
            "v-tab",
            {
              on: {
                click: function($event) {
                  return _vm.selectTab("individual")
                }
              }
            },
            [_vm._v("Huella de Carbono Individual")]
          )
        ],
        1
      ),
      _c("v-divider"),
      _vm.indivitual
        ? _c("EditarVehiculosBase")
        : _vm.general
        ? _c("HuellaCarbonoGeneral")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }